module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='				<li class="charts-list__item">\n							<div class="m-chart '+
((__t=( obj.id ))==null?'':__t)+
'">\n								<div class="m-chart-header">'+
((__t=( obj.def.label ))==null?'':__t)+
'</div>\n<!-- 								<div class="m-chart-body">'+
((__t=( obj.value ))==null?'':__t)+
'</div>\n -->								<div class="m-chart-body">\n									<div class="m-gauge js-gauge" data-label="'+
((__t=( obj.def.unit ))==null?'':__t)+
'" data-autorange="'+
((__t=( getBooleanAsString(obj.def.autoRange) ))==null?'':__t)+
'" data-label="'+
((__t=( obj.def.autorange ))==null?'':__t)+
'" data-digits="'+
((__t=( obj.def.digits ))==null?'':__t)+
'" data-value-digits="'+
((__t=( obj.def.valueDigits ))==null?'':__t)+
'"  data-scale-min="'+
((__t=( obj.def.min ))==null?'':__t)+
'" data-scale-target="'+
((__t=( obj.def.target ))==null?'':__t)+
'" data-scale-max="'+
((__t=( obj.def.max ))==null?'':__t)+
'" data-value="'+
((__t=( obj.value ))==null?'':__t)+
'"></div>\n								</div>\n								<div class="m-chart-footer"></div>\n							</div>\n						</li>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/device-status/show/templates/gauge.html
// module id = 426
// module chunks = 0